export enum ReminderType{
    OneMonthPriorReminderEmail = "One Month Prior Reminder",
    OneWeekPriorReminderEmail = "One Week Prior Reminder",
    OverdueReminderEmail = "Overdue Reminder",
    NonResponsiveReminderEmail = "Non Responsive",
}